import {
  AiOutlineDownload,
  AiOutlineFileImage,
  AiOutlineFileJpg,
  AiOutlineFilePdf,
} from 'react-icons/ai';
import { BiSpreadsheet } from 'react-icons/bi';
import { BsArrowsAngleExpand } from 'react-icons/bs';
import { RiRefreshLine } from 'react-icons/ri';
import Popup from 'reactjs-popup';
import styled from 'styled-components';

interface ContentContainerProps {
  haveTitle?: boolean;
}

interface HeaderStyleProps {
  HeaderJustifyContent?: string;
  HeaderFlexDirectiom?: string;
  HeaderMarginTop?: string;
  HeaderAlignItems?: string;
  HeaderBackgroundColor?: string;
  HeaderPadding?: string;
  title?: string;
}

interface LeftStyleProps {
  LeftFlexDirectiom?: string;
  LeftJustifyContent?: string;
  LeftAlignItems?: string;
}

interface TitleStyleProps {
  titleColor?: string;
  isNotPadding?: boolean;
  titleStyle?: {
    fontWeight?: number | string;
    fontSize?: string;
    margin?: string;
    titleAlign?: string;
  };
}
interface SubtitleStyleProps {
  isNotPadding?: boolean;
  subtitleStyle?: {
    color?: string;
    fontWeight?: number | string;
    fontSize?: string;
    margin?: string;
  };
}

interface CardModalProps {
  modalHeight?: string;
  modalWidth?: string;
}

export const Header = styled.div<HeaderStyleProps>`
  margin-top: ${({ HeaderMarginTop }) => HeaderMarginTop || '0'};
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;

  ${({ HeaderPadding }) =>
    HeaderPadding ? `padding: ${HeaderPadding} ;` : null}

  display: flex;
  flex-direction: ${({ HeaderFlexDirectiom }) => HeaderFlexDirectiom || 'row'};
  justify-content: ${({ HeaderJustifyContent, title }) =>
    HeaderJustifyContent || (title ? 'space-between' : 'flex-end')};
  ${({ HeaderAlignItems }) =>
    HeaderAlignItems ? `align-items: ${HeaderAlignItems}` : ''};
  ${({ HeaderBackgroundColor }) =>
    HeaderBackgroundColor
      ? `background-color: ${HeaderBackgroundColor} ;`
      : null}
`;

export const LeftContainer = styled.div<LeftStyleProps>`
  display: flex;
  width: 100%;
  align-items: ${({ LeftAlignItems }) => LeftAlignItems || 'flex-start'};
  flex-direction: ${({ LeftFlexDirectiom }) => LeftFlexDirectiom || 'column'};
  justify-content: ${({ LeftJustifyContent }) => LeftJustifyContent || 'center'};
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  justify-content: center;
  align-items: center;
`;
export const ContentContainer = styled.div<ContentContainerProps>`
  height: ${({ haveTitle }) => (haveTitle ? '0' : '14px')};
  display: flex;
  flex-direction: row;
  margin-left: auto;
  justify-content: flex-end;
`;

export const ToolsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  position: absolute;
  right: 5px;
  top: 5px;
`;

export const Title = styled.h3<TitleStyleProps>`
  color: ${(props) => props.titleColor || '#475569'};
  font-size: ${(props) => props.titleStyle?.fontSize || '16px'};
  font-weight: ${(props) => props.titleStyle?.fontWeight || '600'};
  line-height: 16px;
  ${({ isNotPadding }) => (isNotPadding ? null : 'padding-bottom: 4px;')};
  height: 25px;
`;

export const Subtitle = styled.h3<SubtitleStyleProps>`
  color: ${(props) => props.subtitleStyle?.color || '#b0b0b0'};
  font-style: normal;
  font-size: ${(props) => props.subtitleStyle?.fontSize || '12px'};
  margin: ${(props) => props.subtitleStyle?.margin || '0'};
  font-weight: ${(props) => props.subtitleStyle?.fontWeight || 'normal'};
  line-height: 14px;
  padding-bottom: 4px;
`;

export const CardModal = styled(Popup)<CardModalProps>`
  &-overlay {
    background-color: #00000020;
  }
  &-content {
    height:${(props) => props.modalHeight || '80vh'};
    width: ${(props) => props.modalWidth || '80vw'};
  }
`;

export const IconContainer = styled.div`
  height: 20px;
  width: 20px;
  padding: 3px;
  margin: 0 8px;
  cursor: pointer;
  margin-top: -5px;
`;

export const ExportButton = styled.div`
  height: 25px;
  width: 25px;
  padding: 3px;
  cursor: pointer;
  font-size: 12px;
  margin-top: -5px;
`;

export const ExportIcon = styled(AiOutlineDownload)`
  height: 100%;
  width: 100%;
`;

export const ExpanderIcon = styled(BsArrowsAngleExpand)`
  height: 100%;
  width: 100%;
`;

export const SpreadsheetIcon = styled(BiSpreadsheet)``;
export const ImageIcon = styled(AiOutlineFileJpg)``;
export const PdfIcon = styled(AiOutlineFilePdf)``;
export const PngIcon = styled(AiOutlineFileImage)``;
export const RefreshIcon = styled(RiRefreshLine)`
  font-size: 20px;
  color: #c5c5c5;
`;

export const RefreshIconContainer = styled.button`
  height: 25px;
  width: 25px;
  background-color: transparent;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;
